module.exports = __webpack_public_path__ + "C.svg?25425f71d40e750066144d24bcce49b4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/C.svg
// module id = 56
// module chunks = 0